/**
 * Dependencies
 */
import React, { useState } from 'react';
import DocumentTitle from 'react-document-title';

import { Box } from '@nerdwallet/currency';
import {
  useFeatureFlag,
  Experiment,
  ExperimentControl,
  ExperimentVariant,
} from '@nerdwallet/features';

// Local Components
import { FEATURE_FLAGS } from '@constants/feature-flags';
import VerticalComparison from '../components/front-page/vertical-comparison/vertical-comparison';
import CCBest from '../components/front-page/cc-best/cc-best';
import Testimonials from '../components/front-page/testimonials/testimonials';
import RegistrationModule from '../components/front-page/registration-module/registration-module';
// todo: Before merge, remove the additional homepage modules that were added for QA
// import RewardsModule from '../components/front-page/rewards-module';
import NewsArticles from '../components/front-page/news-articles/news-articles-container/news-articles-container';
import AnnouncementBanner from '../components/front-page/announcement-banner';
import { EXPERIMENTS } from '../experiments';
import CampaignHighlight from '../components/front-page/campaign-highlight/campaign-highlight';

// Other Local Dependencies
import {
  verticalComparisonContent,
  ccBestContent,
  testimonialsContent,
  registrationModuleContent,
  campaignHighlightContent,
} from '../lib/front-page-content';

const TRAVEL_REDIRECT_TEST_ID =
  EXPERIMENTS.cardfinderTravelRedirectExperiment.id;
const { VARIANT } = EXPERIMENTS.cardfinderTravelRedirectExperiment.variants;

const FrontPage = () => {
  const documentTitle = 'NerdWallet: Make all the right money moves';
  const [showAnnouncementBanner, setShowAnnouncementBanner] = useState(true);
  const { data: wildfireFeatureFlag } = useFeatureFlag({
    featureFlagName: FEATURE_FLAGS.WILDFIRE_POC,
  });

  return (
    <React.Fragment>
      <DocumentTitle title={documentTitle} />
      <Box marginTop={4}>
        <If condition={showAnnouncementBanner && !!wildfireFeatureFlag?.value}>
          <AnnouncementBanner
            handleOnClose={() => setShowAnnouncementBanner(false)}
          />
        </If>

        <Experiment testName={TRAVEL_REDIRECT_TEST_ID}>
          <ExperimentControl>
            <VerticalComparison {...verticalComparisonContent()} />
          </ExperimentControl>
          <ExperimentVariant name={VARIANT}>
            <VerticalComparison {...verticalComparisonContent(true)} />
          </ExperimentVariant>
        </Experiment>
      </Box>
      {/* <Choose>
        <When condition={!!wildfireFeatureFlag?.value}>
          <Box marginBottom={4}>
            <RewardsModule />
          </Box>
        </When>
        <Otherwise> */}
      <RegistrationModule {...registrationModuleContent} />
      <Testimonials {...testimonialsContent} />
      <CampaignHighlight {...campaignHighlightContent} />
      {/* </Otherwise>
      </Choose> */}
      <Box marginY={{ mobile: '2', desktop: '3' }}>
        <NewsArticles />
      </Box>
      <CCBest {...ccBestContent} />
    </React.Fragment>
  );
};

FrontPage.displayName = 'FrontPage';
FrontPage.analyticsName = 'nw_home_page';
FrontPage.segmentPageName = 'homepage';

FrontPage.propTypes = {};

export default FrontPage;
